export const OrderModalStateActions = Object.freeze({
  ADD_ADDRESS: "open add address",
  EDIT_ADDRESS: "open edit address",
  CLOSE: "close and reset state",
  HOME: "open home",
  OPEN_VALIDATE: "open and validate",
});

export const googleMapAPILibraries = ["places"];
